export default __webpack_public_path__ + "static/buildup-2df766eb290732f427ee3f2cfe582a44.png";